import { useState, useEffect } from 'react'
import { loadMicro } from '../utils/micros'

export type MicroProps = {
  microId: string,
  baseUrl: string,
  root: string | HTMLDivElement | null,
  data?: any
}

type MicroModule = (root: string | HTMLDivElement | null, data?: any) => MicroInstance
type MicroInstance = { unmount: () => void }

export function useMicro ({
  microId,
  baseUrl,
  root,
  data
}: MicroProps) {
  const [microModule, setMicroModule] = useState<{ mount: MicroModule } | null>(null)
  const [app, setApp] = useState<MicroInstance | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<Error | null>(null)

  async function getMicro () {
    try {
      setError(null)
      // Unmount micro
      app && (await Promise.resolve(app.unmount()))
      setApp(null)
      setMicroModule(null)
      if (!microId || !baseUrl) return
      // Get micro app
      setLoading(true)
      const micro = await loadMicro(microId, baseUrl)
      setMicroModule({ mount: micro.default || micro })
    } catch (e) {
      console.error(e)
      setError(e as Error)
    } finally {
      setLoading(false)
    }
  }

  async function mountMicro () {
    try {
      // If has micro mounted, unmount first
      app && (await Promise.resolve(app.unmount()))
      setApp(null)
      // Mount micro
      if (microModule && root) {
        setError(null)
        setApp(await Promise.resolve(microModule.mount(root, data)))
      }
    } catch (err) {
      console.error(err)
      setError(err as Error)
    }
  }

  // Get micro

  useEffect(() => {
    getMicro()
  }, [microId, baseUrl])

  useEffect(() => {
    mountMicro()
  }, [microModule, root])

  return {
    app,
    loading,
    error
  }
}
